import { z } from 'zod';

import { type BaseItem } from '../common.js';

export const basePhoneNumberPracticeMappingSchema = z.object({
  organizationId: z.string(),
  headerValue: z.string(),
  practiceId: z.string(),
});

type BasePhoneNumberPracticeMapping = z.infer<typeof basePhoneNumberPracticeMappingSchema>;

export type PhoneNumberPracticeMapping = BasePhoneNumberPracticeMapping & BaseItem;

export type CreateValues = BasePhoneNumberPracticeMapping;
